module.exports = __webpack_public_path__ + "img/9_3.1b6e4507.png";